

export const alertUtil = {
    show:function(title, content){
        // Vue.$bvModal.show("modal-primary");
    } 
    
}